import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["background", "borderRadius", "border", "elevation", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { useTheme } from '@emotion/react';
import * as views from './Paper.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var Paper = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var background = _ref.background,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 10 : _ref$borderRadius,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? "none" : _ref$border,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  return _jsx(views.Wrapper, _objectSpread(_objectSpread({
    background: background || theme.palette.brand.boysenberry[100],
    borderRadius: borderRadius,
    border: border,
    elevation: elevation,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
export default Paper;